import { FunctionGroupInterface } from "../interfaces/FunctionGroupInterface";

export const getFunctionGroupLabel = (
    functionGroups: FunctionGroupInterface[],
): string => {
    if (!functionGroups?.length) {
        return "";
    }

    // Filter alle groepen met lege namen
    const validGroups = functionGroups.filter(
        (group) => group.name.trim() !== "",
    );

    if (!validGroups.length) {
        return "";
    }

    const [firstGroup, ...restGroups] = validGroups;
    const additionalCount =
        restGroups.length > 0 ? `, +${restGroups.length}` : "";

    return `${firstGroup.name}${additionalCount}`;
};
